import { render } from "./EditWorkspace.vue?vue&type=template&id=16123766&scoped=true&ts=true"
import script from "./EditWorkspace.vue?vue&type=script&lang=ts"
export * from "./EditWorkspace.vue?vue&type=script&lang=ts"

import "./EditWorkspace.vue?vue&type=style&index=0&id=16123766&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16123766"]])

export default __exports__